export const FEATURE_FLAGS = {
  suggestLocalCurrencyForConverter: 'specs.stores.suggestLocalCurrencyForConverter',
  suggestAutoCurrencySwitchConverter: 'specs.stores.suggestAutoCurrencySwitchConverter',
  alwaysSuggestCurrency: 'specs.stores.alwaysSuggestCurrency',
  useCurrencySettingsServiceForManageCurrencies: 'specs.stores.useCurrencySettingsServiceForManageCurrencies',
  useCurrencySettingsServiceForManageSuggestion: 'specs.stores.useCurrencySettingsServiceForManageSuggestion',
  hideCurrencyConverterDesignAndAdvancedTabs: 'specs.stores.hideCurrencyConverterDesignAndAdvancedTabs',
  showAutoSwitchToast: 'specs.stores.ShowAutoSwitchToast',
  useCurrencyConverterFlagIconsInSuggestionPopover: 'specs.stores.UseCurrencyConverterFlagIconsInSuggestionPopover',
  enableSuggestedCurrencyAutoSwitchRobust: 'specs.stores.EnableSuggestedCurrencyAutoSwitchRobust',
};
